/* SIGNAL — Global controls (floating back + settings) that overlay all agent views */
import React from 'react';
import { useAuth } from '../auth/AuthContext';
import { useNavigation } from '../App';
import IntelBriefingModal from './IntelBriefingModal';
import internalNavConfig from '../internal/navConfig.json';
import './intel.css';

export default function GlobalControls() {
  const { user, role, logout } = useAuth();
  const nav = useNavigation();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [intelOpen, setIntelOpen] = React.useState(false);

  if (!nav) return null;

  return (
    <>
      {nav.canGoBack && (
        <button
          className="signal-global-back"
          onClick={nav.goBack}
          data-testid="global-back-btn"
          aria-label="Go back"
          title="Go back"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" /><path d="M12 19l-7-7 7-7" />
          </svg>
          <span>BACK</span>
        </button>
      )}

      <button
        className="signal-global-intel-btn"
        onClick={() => setIntelOpen(true)}
        data-testid="global-intel-btn"
        title="Intelligence briefing · cross-agent snapshot"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></svg>
        <span>INTEL</span>
      </button>

      {intelOpen && <IntelBriefingModal onClose={() => setIntelOpen(false)} onNavigate={(a) => nav.navigate(a)} />}

      <div className="signal-global-user-wrap">
        <button
          className="signal-global-user-btn"
          onClick={() => setMenuOpen((v) => !v)}
          data-testid="global-user-btn"
          aria-label="User menu"
          title={user?.email}
        >
          <span className="signal-global-user-dot" />
          <span className="signal-global-user-role">{role === 'admin' ? 'ADMIN' : 'TECH'}</span>
        </button>
        {menuOpen && (
          <>
            <div className="signal-global-backdrop" onClick={() => setMenuOpen(false)} />
            <div className="signal-global-menu" data-testid="global-user-menu">
              <div className="sgm-user">
                <div className="sgm-user-email">{user?.email}</div>
                <div className="sgm-user-role">{role}</div>
              </div>
              <div className="sgm-divider" />
              <button
                className="sgm-item"
                onClick={() => { setMenuOpen(false); nav.openSettings(); }}
                data-testid="global-settings-btn"
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
                <span>Settings</span>
              </button>
              <button
                className="sgm-item"
                onClick={() => { setMenuOpen(false); nav.navigate('nova'); }}
                data-testid="global-home-btn"
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>
                <span>Home (Nova)</span>
              </button>
              <div className="sgm-divider" />
              <div className="sgm-section-label">AGENTS</div>
              <button className="sgm-item" onClick={() => { setMenuOpen(false); nav.navigate('nova'); }} data-testid="global-nav-nova"><span className="sgm-agent-dot" style={{ background: '#e8a598' }} />Nova · Environmental</button>
              <button className="sgm-item" onClick={() => { setMenuOpen(false); nav.navigate('orion'); }} data-testid="global-nav-orion"><span className="sgm-agent-dot" style={{ background: '#00E5FF' }} />Orion · Space Weather</button>
              <button className="sgm-item" onClick={() => { setMenuOpen(false); nav.navigate('vega'); }} data-testid="global-nav-vega"><span className="sgm-agent-dot" style={{ background: '#6366F1' }} />Vega · Infrastructure</button>
              <button className="sgm-item" onClick={() => { setMenuOpen(false); nav.navigate('atlas'); }} data-testid="global-nav-atlas"><span className="sgm-agent-dot" style={{ background: '#059669' }} />Atlas · Geopolitics</button>
              <button className="sgm-item" onClick={() => { setMenuOpen(false); nav.navigate('crew'); }} data-testid="global-nav-crew"><span className="sgm-agent-dot" style={{ background: '#4de2c0' }} />Crew · Production Roundtable</button>
              <button className="sgm-item" onClick={() => { setMenuOpen(false); nav.navigate('karbon'); }} data-testid="global-nav-karbon"><span className="sgm-agent-dot" style={{ background: '#00e5b0' }} />Karbon · Mangrove / Blue Carbon</button>
              <div className="sgm-divider" />
              <div className="sgm-section-label">SYSTEM AGENTS</div>
              {internalNavConfig.map((entry) => (
                <button
                  key={entry.id}
                  className="sgm-item"
                  onClick={() => { setMenuOpen(false); nav.navigate(entry.id); }}
                  data-testid={`global-nav-${entry.id}`}
                >
                  <span className="sgm-agent-dot" style={{ background: '#7ecfc0' }} />
                  {entry.label}
                </button>
              ))}
              <div className="sgm-divider" />
              <button
                className="sgm-item sgm-item-danger"
                onClick={() => { setMenuOpen(false); logout(); }}
                data-testid="global-signout-btn"
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" /></svg>
                <span>Sign out</span>
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}
